 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-fab_3-ios-entry-js","22":"stencil-ion-fab_3-md-entry-js","23":"stencil-ion-img-entry-js","24":"stencil-ion-infinite-scroll_2-ios-entry-js","25":"stencil-ion-infinite-scroll_2-md-entry-js","26":"stencil-ion-input-ios-entry-js","27":"stencil-ion-input-md-entry-js","28":"stencil-ion-loading-ios-entry-js","29":"stencil-ion-loading-md-entry-js","30":"stencil-ion-popover-ios-entry-js","31":"stencil-ion-popover-md-entry-js","32":"stencil-ion-progress-bar-ios-entry-js","33":"stencil-ion-progress-bar-md-entry-js","34":"stencil-ion-radio_2-ios-entry-js","35":"stencil-ion-radio_2-md-entry-js","36":"stencil-ion-reorder_2-ios-entry-js","37":"stencil-ion-reorder_2-md-entry-js","38":"stencil-ion-ripple-effect-entry-js","39":"stencil-ion-spinner-entry-js","40":"stencil-ion-split-pane-ios-entry-js","41":"stencil-ion-split-pane-md-entry-js","42":"stencil-ion-tab-bar_2-ios-entry-js","43":"stencil-ion-tab-bar_2-md-entry-js","44":"stencil-ion-tab_2-entry-js","45":"stencil-ion-text-entry-js","46":"stencil-ion-textarea-ios-entry-js","47":"stencil-ion-textarea-md-entry-js","48":"stencil-ion-toggle-ios-entry-js","49":"stencil-ion-toggle-md-entry-js","50":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"8376ff9f","1":"f94565c4","2":"b9c4c47e","3":"df1a372a","4":"93ea53fc","5":"35c80638","8":"162b835c","9":"9116c9d5","10":"4116eac2","11":"bd88a04e","12":"255c4771","13":"886c6e5f","14":"1be72bd9","15":"2042a976","16":"5e290afa","17":"b03f1ba3","18":"56437b04","19":"234abd28","20":"ae449cae","21":"cae2f409","22":"60c7f9f3","23":"34686199","24":"6e473247","25":"19f8b8a1","26":"a5b4b2ad","27":"af1e3fc6","28":"b280cfd0","29":"338e8451","30":"921425f4","31":"472f031c","32":"e83c011b","33":"af24310d","34":"f1de4386","35":"a0c6f5f4","36":"a788e1ef","37":"7ba3f9f7","38":"d2e81c72","39":"4eb85e9f","40":"0aca846f","41":"091c0a97","42":"8137d755","43":"f79ed5f4","44":"f42f648d","45":"9831f57d","46":"e49deb0a","47":"2252a764","48":"c54a4edc","49":"d01f692c","50":"72f71eb2","52":"165ecee8","53":"abadf60a","54":"ef410e48","55":"d8ab3cec","56":"1beffa87","57":"d10c09cc","58":"db95b43d","59":"f6494052","60":"a019c765","61":"ba104752","62":"3993eb75","63":"c74b0d52","64":"f9135b2b","65":"ed74dee7","66":"5d972c96","67":"30fb915d","68":"565f82d2","69":"36dce6d5","70":"921eed4e","71":"febd75be","72":"fb05fc6a","73":"478ca2d0","74":"5eb3f602","75":"9ba187ba","76":"6944d07c","77":"df72b864","78":"ea5c88fd","79":"ba42201a","80":"b41e0cc7","81":"006adba6","82":"a14d73b0","83":"6e1d4eba","84":"ab6effaa","85":"33bb816b","86":"f28dc761","87":"030829a7","88":"18aee23d","89":"5f0f9d9d","90":"3dd141fa","91":"646eb7ca"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonplocalqueue"] = this["webpackJsonplocalqueue"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
